export default __webpack_public_path__ + "static/media/digitalcard_person_membership-pass.5ff5f947.svg";